import cn from 'classnames';
import { FC, useState } from 'react';
import { useIntl } from 'react-intl';

import { useAppDispatch } from '@/shared/hooks';
import { trackEvent } from '@/shared/lib';
import { Modal, ModalProps } from '@/shared/ui';

import { reportsModel } from '@/entities/reports';

import styles from './ConfirmSignReportModal.module.scss';

type ConfirmSignReportProps = {
  className?: string;
  reportID: string;
  isAllTeethApproved: boolean;
} & Pick<ModalProps, 'isOpen' | 'onCancel' | 'onOk'>;

export const ConfirmSignReportModal: FC<ConfirmSignReportProps> = (props) => {
  const {
    isOpen,
    reportID,
    onCancel: onClose,
    className,
    isAllTeethApproved,
  } = props;

  const [loading, setLoading] = useState(false);

  const { formatMessage } = useIntl();

  const dispatch = useAppDispatch();

  const title = isAllTeethApproved
    ? formatMessage({
        id: 'report.signReport',
        defaultMessage: 'Sign the report',
      })
    : formatMessage({
        id: 'consfirmSignReportModal.approveAll',
        defaultMessage: 'Approve all teeth',
      });

  const handleSign = async () => {
    setLoading(true);
    try {
      await dispatch(
        reportsModel.thunks.approveAllTeethAndSignReport(reportID),
      );
    } finally {
      setLoading(false);

      trackEvent({
        eventName: isAllTeethApproved
          ? 'ReportPageSignReportButtonClicked'
          : 'ReportPageFooterApproveAndSignButtonClicked',
      });

      if (onClose) {
        onClose();
      }
    }
  };

  return (
    <Modal
      data-component="confirm-sign-report-modal"
      isOpen={isOpen}
      title={title}
      onOk={handleSign}
      onCancel={onClose}
      className={cn(styles.container, className)}
      okButtonText="Yes, submit"
      okButtonProps={{ loading, disabled: !isAllTeethApproved }}
    >
      {isAllTeethApproved
        ? 'Are you sure you want to submit your evaluation?'
        : 'Some teeth are not approved. Please check that you provided your evaluation and approved each tooth.'}
    </Modal>
  );
};
